/**
 * External dependencies
 */
import React from "react";

/**
 * Internal dependencies
 */
import { EmptyWrapper, MoreWrapper, PostsWrapper } from "../wrappers";
import { ErrorMessage, useInfinitePosts } from "../utils";
import { PostsLoader } from "../loaders";
import EmptyPosts from "./EmptyPosts";
import LoadMore from "./LoadMore";

/**
 * Configuration
 */
import config from "../config";

const { texts } = config || {};
const { no_posts_found } = texts || {};

const InfinitePosts = ({ filters, perPage, renderPost }) => {
	const {
		posts,
		error,
		loadMore,
		isLoadingInitialData,
		isLoadingMore,
		isReachingEnd,
		isEmpty,
	} = useInfinitePosts(perPage, filters);

	if (error) {
		return <ErrorMessage />;
	}

	if (!posts) {
		return (
			<PostsWrapper>
				<PostsLoader numOfItems={perPage} />
			</PostsWrapper>
		);
	}

	if (isEmpty) {
		return (
			<EmptyWrapper>
				<EmptyPosts title={no_posts_found?.title} text={no_posts_found?.text} />
			</EmptyWrapper>
		);
	}

	return (
		<>
			<PostsWrapper>{posts.map(renderPost)}</PostsWrapper>
			<MoreWrapper>
				<LoadMore
					isVisible={!isLoadingInitialData && !isReachingEnd}
					isLoading={isLoadingMore}
					onClick={loadMore}
				/>
			</MoreWrapper>
		</>
	);
};

export default InfinitePosts;
